import React from 'react'

import { BetterLink } from '~/components/features/BetterLink'
import { compile } from '~/routes/paths'

import { isEnabledTransitionContext } from '../contexts'
import { type DocumentImage } from '../hooks/useFetchDocumentImages'

export type RestoreLinkProps = React.PropsWithChildren<{
  className?: string
  documentImage: DocumentImage
}>

export const RestoreLink = ({
  children,
  className,
  documentImage,
}: RestoreLinkProps) => {
  const isEnabledTransition = React.useContext(isEnabledTransitionContext)
  const to = React.useMemo(
    () =>
      isEnabledTransition
        ? compile('restore', { key: documentImage.restoreKey })
        : undefined,
    [documentImage.restoreKey, isEnabledTransition],
  )

  return (
    <BetterLink
      className={className}
      logEventName="Open saved table and graph"
      rel="noopener noreferrer"
      target="_blank"
      to={to}
    >
      {children}
    </BetterLink>
  )
}
